import { auth } from './firebase';

export class ApiError extends Error {
  constructor(public readonly status: number, message: string, public readonly body?: unknown) {
    super(message);
    this.name = 'ApiError';
  }
}

const API_BASE = '/api';
const TIMEOUT_MS = 15_000;
// Uploads kan ta minutrar (200 filer, 25MB/st). Skippa default-timeouten
// för FormData så Cloud Run-funktionens 540s blir effektiv max-tid.
const UPLOAD_TIMEOUT_MS = 9 * 60_000;

async function getIdToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit & { skipAuth?: boolean } = {},
): Promise<T> {
  const headers = new Headers(init.headers);

  if (!init.skipAuth) {
    const token = await getIdToken();
    if (token) headers.set('Authorization', `Bearer ${token}`);
  }
  if (init.body && !headers.has('Content-Type') && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const isUpload = init.body instanceof FormData;
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers,
    signal: init.signal ?? AbortSignal.timeout(isUpload ? UPLOAD_TIMEOUT_MS : TIMEOUT_MS),
  });

  if (!res.ok) {
    let body: unknown;
    try { body = await res.json(); } catch { /* ignore */ }
    throw new ApiError(res.status, `API ${res.status} ${path}`, body);
  }

  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
